import { useGlobalAppStateStore } from '../../stores/app/GlobalAppStateStore';
import { getShouldEvaluateResult } from '../../utils/getShouldEvaluateResult';

export function useGetShouldEvaluateResult() {
  return getShouldEvaluateResult(useGlobalAppStateStore().hooks.record.useFlags());
}
